import React from 'react'
import { Grid } from 'semantic-ui-react'
import InputField from '../../../commonComponents/formComponents/inputField'
import { useSelector } from 'react-redux'
import { TranslateContext } from '../TranslateContext'
import { restrictDecimal } from '../../../Helper'

const MerchForm5=({ lineItemIndex, invoiceId,merchandiseId ,saveData,updateData,updateCalculatedValue,invoiceIndex,fieldPattern, validateError } ) => {
  
  const invoiceVal =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.invoiceVal) || ''
  const exchRate =useSelector((state) => state.InvoicesReducer.invoices[invoiceIndex]?.exchRate) //useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.exchRate) || ''
  const eurVal = useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.eurVal) || ''
  const statVal =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.statVal) || ''

  const translate = React.useContext(TranslateContext).translate
  const { lineItem } = fieldPattern()?.items
  const invoiceValErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_invoiceVal`])

  return (
    <Grid.Row>
      <Grid.Column width='4' className='divFormFeild b-rw-0'>
        <InputField
          isLabel={false}
          id={`invoiceVal-${invoiceId}-${merchandiseId}`}
          type='number'
          label={translate('INVOICE_VAL', { ns: ['default', 'lineItem'] })}
          value={invoiceVal}
          className='field-bg'
          errors={invoiceValErr&&invoiceValErr?.msg}
          clearInput={false}
          onChange={(value) =>{
            if(restrictDecimal(value))
                updateData({invoiceVal:value})}
          }
          onBlur={(value) =>{
            updateCalculatedValue({invoiceVal:invoiceVal || 0}, 'invoiceVal')
            const key = `invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_invoiceVal`
            validateError({[key]:""},{[key]:value},
                  {[key]:lineItem(invoiceIndex+1, lineItemIndex+1)?.invoiceVal}
            )
          }}
        />
      </Grid.Column>
     
      <Grid.Column width='4' className='divFormFeild b-rw-0'>
        <InputField
          isLabel={false}
          id={`exChangeRate-${invoiceId}-${merchandiseId}`}
          type='number'
          label={translate('EXCHANGE_RATE', { ns: ['default', 'lineItem', 'valueBuildUp'] })}
          value={exchRate}
          className='field-bg'
          clearInput={false}
          isDisabled={true}
          onChange={(value) =>{
            updateData({exchRate:value})
            saveData({exchRate:value || " "})
          }}
          // onBlur={(value) =>{
          //   saveData({exchRate:exchRate || " "})
          // }}
        />
      </Grid.Column>

      <Grid.Column width='4' className='divFormFeild b-rw-0'>
        <InputField
          isLabel={false}
          type='number'
          id={`euroValue-${invoiceId}-${merchandiseId}`}
          label={translate('EUR_VALUE', { ns: ['default', 'lineItem', 'valueBuildUp'] })}
          value={eurVal}
          isDisabled={true}
          className='field-bg'
          onChange={(value) => {
            updateData({eurVal:value})
            saveData({eurVal:value || " "})
          }}
          // onBlur={(value) =>{
          //   saveData({eurVal:eurVal || " "})
          // }}
        />
      </Grid.Column>
      <Grid.Column width='4' className='divFormFeild '>
        <InputField
          isLabel={false}
          id={`statValue-${invoiceId}-${merchandiseId}`}
          type='number'
          label={translate('STATS_VAL', { ns: ['default', 'lineItem', 'valueBuildUp'] })}
          value={statVal}
          isDisabled={true}
          className='field-bg'
          clearInput={false}
          onChange={(value) =>{
            updateData({statVal:value})
            saveData({statVal:statVal || " "})
          }}
          // onBlur={(value) =>{
          //   saveData({statVal:statVal || " "})
          // }}
        />
      </Grid.Column>
    </Grid.Row>
  )
}

export default React.memo(MerchForm5)
